export default class AppController {
  constructor($rcAlerts, NAV_CONTENT, FOOTER_CONTENT) {
    'ngInject';
    this.alerts = $rcAlerts.alerts;
    this.navContent = NAV_CONTENT;
    this.footerContent = FOOTER_CONTENT;
  }
};



// WEBPACK FOOTER //
// ./src/app/app.controller.js